import { useEffect, useRef, useState } from "react";
import { Save, Upload, X } from "react-feather";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { Card, CardContent } from "semantic-ui-react";
import { Card, CardContent } from "@mui/material";
import { FaAlignCenter, FaAlignLeft, FaAlignRight } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import Editor, {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnItalic,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  createButton,
  Toolbar,
} from "react-simple-wysiwyg";
import {
  addAndUpload,
  deleteDocumentList,
  updateAndUpload,
} from "../../api/documentUpload";
import {
  duplicateCheckArticle,
  getArticle,
  saveArticle,
  updateArticle,
} from "../../api/helpCenterApi";
import { getBulkDropdownData } from "../../api/keyvalue";
import DocumentUpload from "../DocumentUpload";
import Button from "../input/Button";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import LoadingSpinner from "../LoadingSpinner";
import Tab from "../Tab";

const BtnAlignCenter = createButton(
  "Align center",
  <FaAlignCenter size={12} />,
  "justifyCenter",
);
const BtnAlignRight = createButton(
  "Align right",
  <FaAlignRight size={12} />,
  "justifyRight",
);
const BtnAlignLeft = createButton(
  "Align left",
  <FaAlignLeft size={12} />,
  "justifyLeft",
);
function CustomEditor({ value, onChange }) {
  return (
    <Editor
      value={value}
      onChange={onChange}
      containerProps={{
        style: {
          minHeight: "300px", // adjust as needed
          height: "auto",
          resize: "vertical", // allow user resizing if desired
        },
      }}
    >
      <Toolbar>
        <BtnRedo />
        <BtnUndo />
        <BtnBold />
        <BtnItalic />
        <BtnUnderline />
        <BtnStrikeThrough />
        <BtnAlignLeft />
        <BtnAlignCenter />
        <BtnAlignRight />
        <BtnBulletList />
        <BtnNumberedList />
        <BtnClearFormatting />
        <BtnLink />
        <BtnStyles />
      </Toolbar>
    </Editor>
  );
}

const AddHelpArticle = ({
  editMode,
  articleId,
  setSelectedKey,
  setEditMode,
  setUpdateNeeded,
  allArticles,
}) => {
  const user = useSelector((state) => state.user);
  const [tab, setTab] = useState(1);
  const [articleName, setArticleName] = useState("");
  const [articleSlug, setArticleSlug] = useState("");
  const [articleStatus, setArticleStatus] = useState(2);
  const [articleActive, setArticleActive] = useState(1);
  const [vedioUrl, setVedioUrl] = useState("");

  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [extensionOptions, setExtensionOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const documentRef = useRef(null);
  const [currentValues, setCurrentValues] = useState({});
  const [isDataLoading, setIsDataLoading] = useState(false);

  const [similarArticleNames, setSimilarArticleNames] = useState([]);
  const [similarArticleSlugs, setSimilarArticleSlugs] = useState([]);
  const [currentErrors, setCurrentErrors] = useState({});
  const [description, setDescription] = useState("");
  function onChange(e) {
    setDescription(e.target.value);
  }

  console.log("description", description);

  const normalize = (text) => text?.toLowerCase().replace(/\s+/g, "") ?? "";

  useEffect(() => {
    if (!articleName.trim()) {
      setSimilarArticleNames([]);
      return;
    }

    const normalizedInput = normalize(articleName);
    if (!allArticles) {
      setSimilarArticleNames([]);
      return;
    }
    const matches = allArticles?.filter((article) => {
      return normalize(article.title).includes(normalizedInput);
    });

    console.log("match article name", articleName);
    console.log("match normalizedInput", normalizedInput);
    console.log("matches", matches);

    setSimilarArticleNames(matches);
  }, [articleName, allArticles]);

  useEffect(() => {
    if (!articleSlug.trim()) {
      setSimilarArticleSlugs([]);
      return;
    }

    const normalizedInput = normalize(articleSlug);
    if (!allArticles) {
      setSimilarArticleSlugs([]);
      return;
    }
    const matches = allArticles?.filter((article) => {
      return normalize(article.slug).includes(normalizedInput);
    });

    setSimilarArticleSlugs(matches);
  }, [articleSlug, allArticles]);

  const handleClose = () => {
    if (!editMode) {
      setSelectedKey(null);
    } else {
      setSelectedKey(1);
      setEditMode(false);
    }
    resetForm();
  };

  useEffect(() => {
    (async () => {
      if (editMode) {
        setIsDataLoading(true);
        const response = await getArticle(articleId);
        setCurrentValues(response);

        setArticleName(response.title);
        setArticleSlug(response.slug);
        setArticleStatus(response.status);
        setArticleActive(response.active);
        setVedioUrl(response.videoEmbedHtml);
        setDescription(response.bodyHtml);

        // const documents = await getDocumentByOpeAndRef(25, articleId);
        // setDocuments(documents);
        setIsDataLoading(false);
      }
    })();
  }, [editMode, articleId]);

  useEffect(() => {
    (async () => {
      setIsDropdownLoading(true);
      const {
        status,
        active,
        doc_type: docTypeOpt,
        file_type: fileTypeOpt,
        "file_name#4": fileNameOpt,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "active" },
        { key: "doc_type" },
        { key: "file_type" },
        { key: "file_name", group: "4" },
      ]);

      setStatusOpt(status);
      setActiveOpt(active);
      setDocumentTypeOptions(docTypeOpt);
      setExtensionOptions(fileTypeOpt);
      setFileNameOptions(fileNameOpt);

      setIsDropdownLoading(false);
    })();
  }, []);

  // function isValidOneDriveIframe(input) {
  //   const iframeRegex =
  //     /<iframe\s+[^>]*src=["'](https:\/\/1drv\.ms\/v\/c\/[^"']+)["'][^>]*><\/iframe>/i;
  //   const match = input.match(iframeRegex);

  //   if (match && match[1]) {
  //     return true; // Valid OneDrive iframe
  //   } else {
  //     return false; // Not a valid OneDrive iframe
  //   }
  // }

  // function isValidOneDriveIframe(input) {
  //   const iframeRegex = /<iframe\s+[^>]*src=["'][^"']+["'][^>]*><\/iframe>/i;
  //   return iframeRegex.test(input);
  // }

  function isValidLink(input) {
    const iframeRegex =
      /<iframe\s+[^>]*src=["']https?:\/\/(?:onedrive\.live\.com|(?:www\.)?youtube\.com|youtu\.be)[^"']*["'][^>]*><\/iframe>/i;

    const urlRegex =
      /^https?:\/\/(?:onedrive\.live\.com|(?:www\.)?youtube\.com\/watch\?v=[\w-]+|youtu\.be\/[\w-]+)/i;

    return iframeRegex.test(input) || urlRegex.test(input);
  }

  const validatePayload = (payload) => {
    let errors = {};
    if (payload.title === "") {
      errors = {
        ...errors,
        title: "Article name is required",
      };
    }
    if (payload.slug === "") {
      errors = {
        ...errors,
        slug: "Article slug is required",
      };
    }
    if (payload.url !== "" && !isValidLink(payload.url)) {
      errors = {
        ...errors,
        url: "Invalid URL",
      };
    }
    return errors;
  };

  const nextButtonHandler = () => {
    switch (tab) {
      case 1: {
        const errors = validatePayload({
          title: articleName,
          slug: articleSlug,
          url: vedioUrl ? vedioUrl : "",
        });
        if (Object.entries(errors).length > 0) {
          setCurrentErrors(errors);
          setIsSubmitLoading(false);
          toast.error("Fill the required fields correctly..", {
            autoClose: 5000,
            containerId: "Modal",
          });
          return;
        }
        setCurrentErrors({});
        setTab(2);
        break;
      }
      default:
    }
  };

  const resetForm = () => {
    setTab(1);
    setArticleName("");
    setArticleSlug("");
    setArticleStatus(2);
    setArticleActive(1);
    setVedioUrl("");
    setArticleActive(1);
    setArticleStatus(2);
    setDescription("");
    // setCurrentValues({});
    setCurrentErrors({});
  };

  const createArticle = async () => {
    setIsSubmitLoading(true);
    try {
      const errors = validatePayload({
        title: articleName,
        slug: articleSlug,
        url: vedioUrl ? vedioUrl : "",
      });
      if (Object.entries(errors).length > 0) {
        setCurrentErrors(errors);
        setIsSubmitLoading(false);
        toast.error("Fill the required fields correctly..", {
          autoClose: 5000,
          containerId: "Modal",
        });
        return;
      }

      const titleCount = await duplicateCheckArticle({
        text: articleName,
        type: 1,
      });

      if (titleCount === null) {
        toast.error("An error occurred", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }
      if (titleCount > 0) {
        toast.error("Article name already exists", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }

      const slugCount = await duplicateCheckArticle({
        text: articleSlug,
        type: 2,
      });

      if (slugCount === null) {
        toast.error("An error occurred", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }
      if (slugCount > 0) {
        toast.error("Article slug already exists", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }
      const response = await saveArticle({
        title: articleName,
        slug: articleSlug,
        status: articleStatus,
        active: articleActive,
        videoEmbedHtml: vedioUrl,
        viewCount: 0,
        bodyHtml: description ? description.toString() : "",
        author: user.username,
      });

      if (response.status === 200 && response.data !== null) {
        const documents = documentRef.current.getData();
        let hasUploadErrors = false;
        for (let doc of documents) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append(
            "documentRequest",
            JSON.stringify({
              ...rest,
              docReference: response?.data?.articleId,
            }),
          );
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Modal",
            });
          } else {
            hasUploadErrors = true;
            documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Modal",
              },
            );
          }
        }
        toast.success("Article added successfully!", {
          autoClose: 5000,
          containerId: "Modal",
        });
        if (hasUploadErrors) {
          setIsSubmitLoading(false);
          return;
        }

        resetForm();
        setUpdateNeeded(true);
        handleClose();
      }
    } catch (error) {
      console.error(error);
    }
    setIsSubmitLoading(false);
  };

  const editArticle = async () => {
    setIsUpdating(true);
    try {
      const errors = validatePayload({
        title: articleName,
        slug: articleSlug,
        url: vedioUrl ? vedioUrl : "",
      });
      if (Object.entries(errors).length > 0) {
        setCurrentErrors(errors);
        setIsSubmitLoading(false);
        toast.error("Fill the required fields correctly..", {
          autoClose: 5000,
          containerId: "Modal",
        });
        return;
      }

      const titleCount = await duplicateCheckArticle({
        text: articleName,
        type: 1,
      });

      if (titleCount === null) {
        toast.error("An error occurred", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }

      if (titleCount > 1) {
        toast.error("Article name already exists", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }

      const slugCount = await duplicateCheckArticle({
        text: articleSlug,
        type: 2,
      });

      if (slugCount === null) {
        toast.error("An error occurred", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }

      if (slugCount > 1) {
        toast.error("Article slug already exists", {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        return;
      }

      const response = await updateArticle({
        articleId: currentValues.articleId,
        title: articleName,
        slug: articleSlug,
        status: articleStatus,
        active: articleActive,
        videoEmbedHtml: vedioUrl,
        viewCount: currentValues.viewCount,
        bodyHtml: description ? description.toString() : "",
        author: user.username,
      });

      if (response.status === 200 && response.data !== null) {
        const documents = documentRef.current.getData();
        let hasUploadErrors = false;

        for (let doc of documents.created) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await addAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Modal",
            });
          } else {
            hasUploadErrors = true;
            documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error adding document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Modal",
              },
            );
          }
        }
        for (let doc of documents.modified) {
          const { file, ...rest } = doc;
          const formData = new FormData();
          formData.append("multipartFile", doc.file);
          formData.append("documentRequest", JSON.stringify(rest));
          formData.append("isImage", rest.docCategory === 1);
          const res = await updateAndUpload(formData);
          if (res && res?.responseCode === "2040") {
            toast.success(res?.message, {
              autoClose: 5000,
              containerId: "Modal",
            });
          } else {
            hasUploadErrors = true;
            documentRef.current.markUploadFailed(doc.id ?? doc.fileName);
            toast.error(
              res?.message || `Error updating document ${doc.docName}`,
              {
                autoClose: 5000,
                containerId: "Modal",
              },
            );
          }
        }

        if (documents?.deleted.length > 0) {
          await deleteDocumentList({
            docIdList: documents?.deleted,
          });
          toast.success("Documents deleted successfully!", {
            autoClose: 5000,
            containerId: "Modal",
          });
        }
        toast.success("Article updated successfully!", {
          autoClose: 5000,
          containerId: "Modal",
        });
        if (hasUploadErrors) {
          setIsUpdating(false);
          return;
        }
        resetForm();
        setUpdateNeeded(true);
        handleClose();
      }
    } catch (error) {
      console.error(error);
    }
    setIsUpdating(false);
  };

  return (
    <>
      {isDataLoading || isDropdownLoading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <div className="help-center-Add-header">
            <X
              color="black"
              size={30}
              className="help-back-icon"
              onClick={handleClose}
              style={{
                position: "absolute",
                right: 20,
                top: 20,
                cursor: "pointer",
                zIndex: "1000",
              }}
            />
          </div>
          <Card style={{ width: "100%", height: "100%" }}>
            <CardContent>
              <div className="ui tabular menu top attached">
                <Tab
                  Icon={Save}
                  onClick={() => {
                    setTab(1);
                  }}
                  active={tab === 1}
                  label="Article"
                />
                <Tab
                  Icon={Upload}
                  onClick={() => {
                    setTab(2);
                  }}
                  active={tab === 2}
                  label="Documents"
                />
              </div>

              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 1 ? "block" : "none" }}
              >
                {isDropdownLoading ? (
                  <LoadingSpinner />
                ) : (
                  <div className="ui form">
                    <div className="field">
                      <Input
                        required={true}
                        type={"text"}
                        label="Article Name"
                        value={articleName}
                        placeholder="Article Name"
                        onChange={(e) => setArticleName(e.target.value)}
                        error={currentErrors.title}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { title: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    </div>
                    {editMode && similarArticleNames?.length === 1
                      ? ""
                      : similarArticleNames?.length > 0 && (
                          <div
                            style={{
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "10px",
                              background: "#f9f9f9",
                            }}
                          >
                            <strong>Similar Article Names:</strong>
                            <ul style={{ paddingLeft: "20px" }}>
                              {similarArticleNames?.map((article) => (
                                <li key={article.articleId}>{article.title}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                    <div className="field">
                      <Input
                        required={true}
                        type={"text"}
                        label="Slug"
                        value={articleSlug}
                        placeholder="Slug"
                        onChange={(e) => setArticleSlug(e.target.value)}
                        error={currentErrors.slug}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { slug: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    </div>
                    {editMode && similarArticleSlugs?.length === 1
                      ? ""
                      : similarArticleSlugs?.length > 0 && (
                          <div
                            style={{
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              padding: "10px",
                              background: "#f9f9f9",
                            }}
                          >
                            <strong>Similar Article Slugs:</strong>
                            <ul style={{ paddingLeft: "20px" }}>
                              {similarArticleSlugs?.map((article) => (
                                <li key={article.articleId}>{article.slug}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                    <div className="field">
                      <Input
                        type={"text"}
                        label="Video URL"
                        value={vedioUrl}
                        placeholder="URL"
                        onChange={(e) => setVedioUrl(e.target.value)}
                        error={currentErrors.url}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { url: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                        style={{ marginBottom: "0px" }}
                      />
                      <small style={{ marginTop: "0px" }}>
                        (URL must be a iframe URL.)
                      </small>
                    </div>
                    <div className="field">
                      <label>Article Description</label>
                      <CustomEditor
                        value={description}
                        onChange={onChange}
                        containerProps={{ style: { resize: "vertical" } }}
                      />
                    </div>
                    <div className="two fields">
                      <Dropdown
                        required={true}
                        label="Status"
                        placeholder="Status"
                        options={statusOpt}
                        value={articleStatus}
                        onChange={(e, data) => setArticleStatus(data.value)}
                        clearable={false}
                      />
                      <Dropdown
                        required={true}
                        label="Active"
                        placeholder="Active"
                        options={activeOpt}
                        value={articleActive}
                        onChange={(e, data) => setArticleActive(data.value)}
                        clearable={false}
                      />
                    </div>
                  </div>
                )}
              </div>

              <div
                className="ui bottom attached active tab segment"
                style={{ display: tab === 2 ? "block" : "none" }}
              >
                <DocumentUpload
                  isLoading={isDropdownLoading}
                  opeType={25}
                  ref={documentRef}
                  reference={
                    currentValues
                      ? currentValues.articleId
                        ? currentValues.articleId
                        : null
                      : null
                  }
                  dropdown={{
                    documentTypeOptions: documentTypeOptions,
                    extensionOptions: extensionOptions,
                    statusOptions: statusOpt,
                    fileNameOptions: fileNameOptions,
                    activeOptions: activeOpt,
                  }}
                  editMode={editMode}
                  currentValues={
                    editMode && currentValues?.documents !== null
                      ? currentValues?.documents
                      : null
                  }
                  isOnTheModal={true}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {tab > 1 && (
                    <Button
                      template="back"
                      tab={tab - 1}
                      onClick={() => setTab(1)}
                    />
                  )}
                  {tab < 2 && (
                    <Button
                      template="next"
                      tab={tab + 1}
                      onClick={nextButtonHandler}
                    />
                  )}
                  {editMode ? (
                    <Button
                      label={"Update"}
                      isLoading={isSubmitLoading}
                      onClick={editArticle}
                      Icon={FaPencil}
                    />
                  ) : tab === 2 && !isDropdownLoading ? (
                    <Button
                      label={"Save"}
                      isLoading={isSubmitLoading}
                      onClick={createArticle}
                      Icon={Save}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}
      {isSubmitLoading && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Creating...`} />
        </div>
      )}
      {isUpdating && (
        <div className="blur-overlay">
          <LoadingSpinner message={`Updating...`} />
        </div>
      )}
    </>
  );
};

export default AddHelpArticle;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
